import React from "react";
import { Dropdown, DropdownMenu, DropdownToggle,DropdownItem } from 'reactstrap';
import ReactQueryParams from 'react-query-params';
import moment from "moment";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { SingleDatePicker } from "react-dates";
import classNames from "classnames";
import {fetchPrizeDataIfNeeded} from '../redux/actions/PrizeActions';
import * as TextManager from "../modules/languages/TextManager";
import {connect} from "react-redux";

class WeekPicker extends ReactQueryParams {
    constructor(props) {
        super(props);
        const currentMoment = moment();
        this.state = {
            //dropdownOpen: false,
            focused: false,
            selectedWorkWeek: currentMoment.week(),
            selectedYear: currentMoment.year(),
            hoveredDays: this.calculateActiveWeek(currentMoment),
            workWeekMarginLeft: 0
        };
    }


    /*toggle = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    };*/

    openPicker = () => {
        /*if (!this.state.focused) {
            this.setState({
                focused: true
            });
        }*/

        this.setState({
            focused: !this.state.focused
        });

    };

    isDayHighlighted = date => {
        const { hoveredDays } = this.state;
        let isHighlighted = false;
        hoveredDays.forEach(hoveredDay => {
            const isDayOfMonthMatch = hoveredDay.date() === date.date();
            const isMonthMatch = hoveredDay.month() === date.month();
            const isYearMatch = hoveredDay.year() === date.year();
            if (isDayOfMonthMatch && isMonthMatch && isYearMatch) {
                isHighlighted = true;
            }
        });
        return isHighlighted;
    };

    calculateActiveWeek = date => {
        const mon = date.clone().startOf("week");
        const tue = mon.clone().add(1, "d");
        const wed = mon.clone().add(2, "d");
        const thu = mon.clone().add(3, "d");
        const fri = mon.clone().add(4, "d");
        const sat = mon.clone().add(5, "d");
        const sun = mon.clone().add(6, "d");
        return [sun, mon, tue, wed, thu, fri, sat];

        /*const sun = date.clone().startOf("week");
        const mon = sun.clone().add(1, "d");
        const tue = sun.clone().add(2, "d");
        const wed = sun.clone().add(3, "d");
        const thu = sun.clone().add(4, "d");
        const fri = sun.clone().add(5, "d");
        const sat = sun.clone().add(6, "d");

        return [mon, tue, wed, thu, fri, sat, sun];*/
    };

    onDateHovered = date => {
        this.setState({
            hoveredDays: this.calculateActiveWeek(date)
        });
    };

    onDateChange = date => {

        const selectedYear = date.year();
        const selectedWorkWeek = date.week();
        this.setState({
            selectedYear,
            selectedWorkWeek,
            focused: false
        });

        this.setQueryParams({
            date: 'custom',
            startDate: date.format('YYYY-MM-DD')+"T00:00:00Z",
            endDate: date.clone().add(7, 'd').format('YYYY-MM-DD')+"T00:00:00Z"
        });

        if(this.props.endpoint === "prize"){
            this.props.dispatch(fetchPrizeDataIfNeeded(this.queryParams));
        }
    };

    renderCalendarDay = date => {
        const dayClasses = classNames(
            "CalendarDay",
            "CalendarDay__default",
            "CalendarDay_1",
            "CalendarDay__default_2"
        );
        let style = {
            width: "39px",
            height: "38px"
        };

        if (date.day) {
            const dayOfMonth = date.day.date();
            const isHighlighted = this.isDayHighlighted(date.day);
            let style = {
                width: "39px",
                height: "38px",
                backgroundColor: isHighlighted ? "#42a5f5" : "white",
                color: isHighlighted ? "white" : "black"
            };

            return (
                <td
                    style={style}
                    className={dayClasses}
                    onClick={() => this.onDateChange(date.day)}
                    onMouseEnter={() => this.onDateHovered(date.day)}
                >
                    {dayOfMonth}
                </td>
            );
        } else {
            return <td style={style} className={dayClasses} />;
        }
    };

    previousWeek = () => {
        const { selectedWorkWeek, selectedYear } = this.state;
        let newSelectedWorkWeek = selectedWorkWeek - 1;
        let newSelectedYear = selectedYear;
        if (newSelectedWorkWeek === 0) {
            newSelectedWorkWeek = 52;
            newSelectedYear = selectedYear - 1;
        }
        const date = moment()
            .year(newSelectedYear)
            .isoWeek(newSelectedWorkWeek);
        this.setState({
            selectedYear: newSelectedYear,
            selectedWorkWeek: newSelectedWorkWeek,
            hoveredDays: this.calculateActiveWeek(date)
        });
    };

    nextWeek = () => {
        const { selectedWorkWeek, selectedYear } = this.state;
        let newSelectedWorkWeek = selectedWorkWeek + 1;
        let newSelectedYear = selectedYear;
        if (newSelectedWorkWeek === 53) {
            newSelectedWorkWeek = 1;
            newSelectedYear = selectedYear + 1;
        }
        const date = moment()
            .year(newSelectedYear)
            .isoWeek(newSelectedWorkWeek);
        this.setState({
            selectedYear: newSelectedYear,
            selectedWorkWeek: newSelectedWorkWeek,
            hoveredDays: this.calculateActiveWeek(date)
        });
    };

    render() {
        const { focused, selectedWorkWeek, selectedYear } = this.state;
        const { openPicker, renderCalendarDay } = this;
        const date = moment()
            .year(selectedYear)
            .week(selectedWorkWeek)
            .startOf("week");
            //.isoWeek(selectedWorkWeek)

        let dateName = '';

        if(this.queryParams.startDate) {
            let start = moment(this.queryParams.startDate, 'YYYY-MM-DD');
            let end = moment(this.queryParams.endDate, 'YYYY-MM-DD');
            
            dateName = start.format('DD-MM-YYYY') + " / " + end.format('DD-MM-YYYY');
        }
        else {
            const dateEnd = date.clone().add(7, 'd');
            dateName = date.format('DD-MM-YYYY') + " / " + dateEnd.format('DD-MM-YYYY');
        }

        return (
            <Dropdown isOpen={this.state.focused} toggle={this.openPicker}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.openPicker}
                    data-toggle="dropdown"
                    aria-expanded={this.state.focused}
                >
                    <p>
                        {dateName}
                        <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                        </svg>
                    </p>
                </DropdownToggle>
                <style>
                    {`
                            .DateInput {
                              display:none;
                            }
                            .SingleDatePicker {
                              position: initial;
                            }
                        `}
                </style>
                <SingleDatePicker
                    focused={focused} // PropTypes.bool
                    date={date}
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                    id="single_date_picker" // PropTypes.string.isRequired,
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel={true}
                    isDayBlocked={() => false}
                    isOutsideRange={() => false}
                    renderCalendarDay={renderCalendarDay}
                />
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData
    };
};

export default connect(mapStateToProps)(WeekPicker);